import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";
import { PMDialog } from "../../utils/PMDialog";
import {
  createProjectActivityGroup,
  updateProjectActivityGroup,
} from "../../../api/project_activity";

export function ProjectActivityGroupDialog({
  open,
  onClose,
  projectId,
  group,
  nextRowOrder = 0,
  onSaved,
}) {
  const { t } = useTranslation();
  const [title, setTitle] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setTitle(group?.title || "");
  }, [open, group]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = title.trim();
    if (!trimmed) {
      toast.error(t("project.activities.group_title_required"));
      return;
    }
    if (!projectId) return;

    setSaving(true);
    try {
      const saved = group?.id
        ? await updateProjectActivityGroup(projectId, group.id, { title: trimmed })
        : await createProjectActivityGroup(projectId, {
            title: trimmed,
            row_order: nextRowOrder,
          });
      toast.success(
        group?.id
          ? t("project.activities.group_updated")
          : t("project.activities.group_created")
      );
      onSaved?.(saved);
      onClose?.();
    } catch (error) {
      console.error(error);
      toast.error(t("project.activities.group_save_error"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title={
        group?.id
          ? t("project.activities.group_edit")
          : t("project.activities.group_new")
      }
      size="md"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            {t("project.activities.group_title")}
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder={t("project.activities.group_title_placeholder")}
            autoFocus
            className="block w-full rounded-md border-slate-300 shadow-sm focus:border-[#1463C7] focus:ring-[#1463C7] sm:text-sm"
          />
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            {t("Cancel")}
          </button>
          <button
            type="submit"
            disabled={saving}
            className="inline-flex items-center rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm disabled:opacity-60"
            style={{ background: "#1463C7" }}
          >
            {saving ? t("project.activities.saving") : t("project.activities.save")}
          </button>
        </div>
      </form>
    </PMDialog>
  );
}
